<template>
  <div :style="{zIndex}" :class="[baseCss, position, app ? 'bcq-app-level' : null, rounded ? 'rounded' : null, 'transition-all', 'duration-300', lightsOut ? `${baseCss}-lights-out` : null, transparent ? ['bg-transparent'] : setBgColor(), setTextColor(), `shadow-${elevation}`, 'select-none', 'whitespace-nowrap']">
    <table-layout equal-cells y-align="middle" :class="[`text-${size}`]" :style="{height}">
      <row>
        <cell x-align="left" :class="['py-1', 'px-2', `${baseCss}-left`, 'truncate']" v-if="$slots.left">
          <slot name="left" />
        </cell>
        <cell :style="{width: widthRight}" x-align="right" :class="['py-1', 'px-2', `${baseCss}-right`, 'truncate']" v-if="$slots.right">
          <slot name="right" />
        </cell>
      </row>
    </table-layout>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'SystemBar',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('system-bar', [])
    }
  },
  props: {
    app: {
      type: Boolean
    },
    position: {
      type: String,
      default: 'static',
      validator: value => {
        return ['static', 'relative', 'absolute', 'fixed'].includes(value)
      }
    },
    transparent: {
      type: Boolean
    },
    zIndex: {
      type: Number,
      default: 1000
    },
    rounded: {
      type: Boolean
    },
    height: {
      type: String,
      default: 'auto'
    },
    bgColor: {
      type: String,
      default: 'gray'
    },
    bgColorLightness: {
      type: Number,
      default: 300
    },
    color: {
      type: String,
      default: 'gray'
    },
    colorLightness: {
      type: Number,
      default: 900
    },
    lightsOut: {
      type: Boolean
    },
    size: {
      type: String,
      default: 'xs',
      validator: value => {
        return ['xs', 'sm', 'base', 'lg', 'xl'].includes(value)
      }
    },
    widthRight: {
      type: String,
      default: '40%'
    }
  }
}
</script>
<style>
.bcq-system-bar .bcq-icon
{
  color: inherit !important;
  font-size: inherit !important;
}

.bcq-system-bar.bcq-system-bar-lights-out
{
  filter: grayscale(100%);
  opacity: .5;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/system-bar/system-bar.vue